
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import { InsurStore} from '@/views/stencil/detail/store'
import List from "../list";
const staticObj = {
'INSURED_INFO':{
last1:'insur_insurinfoinput_holderself_click', //本人
last2:'insur_insurinfoinput_holderparent_click', //父母
last3:'insur_insurinfoinput_holdermate_click', //配偶
last4:'insur_insurinfoinput_holderchild_click' 
},
'INSURED_SOCIAL':{
last0:'insur_insurinfoinput_socialinsurance_no_click', //无社保
last1:'insur_insurinfoinput_socialinsurance_yes_click' 
},
'PAY_LENGTH':{
last1:'insur_insurinfoinput_payyear_click',//一次缴清
else:'insur_insurinfoinput_paymonth_click',//按月缴清
}

}
export default {
data() {
return {
currentValue:'',
currenItem:{
checked: null,
first: "",
last: null,
},
modeShow:false,
listInfo:[
{
setTitle:'社保包含：',
setContent:'新农村合作医疗、城镇居民医保、城镇职工医保、城乡居民医保、少儿医保、公费医保等。'
}
]
}
},
props: {
data: {
type: Object,
default:()=>{
return {
value:'',    //默认选中
elementCode:element.elementCode,                            elementEnums:element.elementEnums,                         ruleEnums:element.ruleEnums,                            elementName:element.elementName,
showName:element.showName,
isCount:element.isCount,    //是否为算费因子
moduleCode:moduleCode,  // 所属哪个模块
isRequired:element.isRequired,   //是否必填
list:[]  
}
}
},
styles:{  //自定义特殊样式
type: Object,
default:()=>{
return {}
}
},
value: {
type: Object,
default:()=>{
return {
value:'',
}
}
},
},
components: {
Tab,
TabItem,
List
},
mounted(){

if(this.data.elementEnums != 'INSURED_SOCIAL'){
this.currenItem  = (this.data.list[0])
}
this.input()

if(this.data.elementEnums == 'INSURED_INFO'){
InsurStore.relationship = this.currenItem.last
}
},












methods: {

input(){
let obj = this.getPostData(this.currenItem)
this.$emit('input', obj)


if(this.currenItem.last!=='' &&  staticObj.hasOwnProperty(this.data.elementEnums)){
let staticName = (staticObj[this.data.elementEnums])['last'+this.currenItem.last];
if(staticName){
this.STATISTICS_CONFIG[staticName]();
}else{

if(this.data.elementEnums == 'PAY_LENGTH'){
let name = (staticObj[this.data.elementEnums])['else']
this.STATISTICS_CONFIG[name]()
}
}
}


},

handler(item){
this.currenItem = item
const postItem  = this.getPostData(item)

this.$emit("change",postItem);

this.input()


if(this.data.elementEnums == 'INSURED_INFO'){
InsurStore.relationship = item.last
}
},

getPostData(newValue){
return  {
value:newValue.first, //选中值
last:newValue.last,  //选中值
elementCode:this.data.elementCode,                        elementEnums:this.data.elementEnums,                     elementName:this.data.elementName,
showName:this.data.showName,
ruleEnums:this.data.ruleEnums,                        isCount:this.data.isCount,    //是否为算费因子
moduleCode:this.data.moduleCode,  // 所属哪个模块
isRequired:this.data.isRequired,   //是否必填
}

},

showModel(){
this.modeShow = true;
this.STATISTICS_CONFIG.insur_insurinfoinput_socialinsuranceinfo_click()
}
},
}
